/*
 * @Author: Dom
 * @Date: 2022-05-18 14:36:20
 * @LastEditTime: 2022-07-29 16:45:55
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\authent\locales\zh-TW.ts
 */
export default{
    'page.personal.center.account': '賬號認證',
    'page.personal.center.customer': '客戶信息',
    'page.personal.center.registered': '註冊賬戶',
    'page.personal.center.notcertified': '未認證',
    'page.personal.center.certifing': '認證中',
    'page.personal.center.certified': '已認證',
    'page.personal.center.certifiedfail': '認證失敗',
    'page.personal.center.authstatus': '認證狀態',
    'page.personal.center.customernumber': '客戶編碼',
    'page.personal.center.password': '密碼',
    'page.personal.center.modify': '修改',
    'page.personal.center.customertype': '客戶類型',
    'page.personal.center.person': '個人',
    'page.personal.center.enterprise': '企業',
    'page.personal.center.contractstatus': '合同狀態',
    'page.personal.center.notsigned': '未簽署',
    'page.personal.center.signeing': '簽署中',
    'page.personal.center.clicksign': '點擊簽署',
    'page.personal.center.signed': '已簽署',
    'page.personal.center.phonebind': '綁定手機號碼',
    'page.personal.center.clickbind': '點擊綁定',
    'page.personal.center.clickchange': '點擊修改',
    'page.personal.center.title.changepassword': '修改密碼',
    'page.personal.center.title.bindphone': '綁定手機號碼',
    'page.personal.center.title.changephone': '修改手機號碼',
    'page.personal.center.title.modify': '修改',
}
